import React from "react";
import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { useStyles } from "./styles";
import { Stack } from "@mui/material";
import { Timeline } from "../../components/Timeline";
import { Company } from "./Company";
import { Security } from "./Security";
import { Users } from "./Users";
import { Stores } from "./Stores";

export function AccountSettings() {
  const styles = useStyles();
  const tabs = [
    {
      label: "Empresa",
      index: 0,
      children: <Company />,
    },
    {
      label: "Usuarios",
      index: 1,
      children: <Users />,
    },
    {
      label: "Lojas",
      index: 2,
      children: <Stores />,
    },
    {
      label: "Segurança",
      index: 3,
      children: <Security />,
    },
  ];
  return (
    <Stack>
      <Grid container direction="column" spacing={2}>
        <Grid item className={styles.item}>
          <Box pt={1} pl={0}>
            <Typography variant="h4" noWrap className={styles.titulo}>
              Configurações da conta
            </Typography>
            <Typography noWrap className={styles.subTitulo}>
              Configure a sua empresa, usuários e lojas.
            </Typography>
          </Box>
        </Grid>
        <Grid item className={styles.item}>
          <Box>
            <Timeline tabs={tabs} padding="0px 0 0 0" />
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
}
